import { normalizeClientServiceInterval } from "./intervalTypesMap";

const INTERVAL_TYPE_ENUM_MAP = {
    Weekly: 0,
    BiWeekly: 1,
    "Bi-Weekly": 1,
    SemiMonthly: 2,
    "Semi-Monthly": 2,
    Monthly: 3,
    Quarterly: 4,
    Annually: 5,
};

const ONE_TIME_VALUES = new Set(["", "One-time", "OneTime", null, undefined]);

export const getClientServiceRecurrencePayload = (intervalValue) => {
    const normalizedInterval = normalizeClientServiceInterval(intervalValue);

    if (ONE_TIME_VALUES.has(normalizedInterval)) {
        return {
            recurrenceType: 0,
            intervalType: null,
        };
    }

    return {
        recurrenceType: 1,
        intervalType:
            Object.prototype.hasOwnProperty.call(
                INTERVAL_TYPE_ENUM_MAP,
                normalizedInterval,
            )
                ? INTERVAL_TYPE_ENUM_MAP[normalizedInterval]
                : null,
    };
};
